import { Chip } from "@mui/material";
import React from "react";

const InquiryStatusWidget = ({ status, fontSize = "12px", className }) => {
  const render = () => {
    switch (`${status}`?.toLowerCase()) {
      case "open":
      case "1":
        return (
          <Chip
            label="open"
            color="primary"
            className={`!text-[${fontSize}] shadow-xl tracking-wider uppercase font-medium !h-[25px] ${className}`}
          />
        );
      case "completed":
      case "3":
        return (
          <Chip
            label="completed"
            color="success"
            className={`!text-[${fontSize}] shadow-xl tracking-wider uppercase font-medium !h-[25px] ${className}`}
          />
        );
      case "closed":
      case "2":
        return (
          <Chip
            label="closed"
            color="gray"
            className={`!text-[${fontSize}] shadow-xl tracking-wider uppercase font-medium !h-[25px] ${className}`}
          />
        );
      default:
        break;
    }
  };
  return <div> {render()}</div>;
};

export default InquiryStatusWidget;
